import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'
import setupPDFWorker from './utils/pdfWorkerSetup'
import { SubscriptionProvider } from './context/SubscriptionContext'
import { AuthProvider } from './context/FirebaseAuthContext'

// PDF.js worker'ını yapılandır
setupPDFWorker();


ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <SubscriptionProvider>
          <App />
        </SubscriptionProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
